import { defineComponent, h, ref } from 'vue';
import { box, col, cols } from '@/ui/components';
import { issueCreate } from '@/ui/components/issue/IssueCreate';
import { IssueCreatePageLogs } from '@/ui/pages/issue/IssueCreatePageLogs';
import { useTask } from '@/ui/concerns';
import { createComment } from '@/services/api/resources/issue/v2';
import { VNodeData } from 'vue/types/vnode.d';
import { IssueRecordEditable } from '@/ui/pages/issue/issueTypes';

interface IssueCreateWithLogsProps {
  mergeAttributes?: Partial<IssueRecordEditable>;
  hideSendButton?: boolean;
}

export const IssueCreateWithLogs = defineComponent<IssueCreateWithLogsProps>({
  name: 'IssueCreateWithLogs',
  props: ['mergeAttributes', 'hideSendButton'],
  setup(props, context) {
    const commentsToCreate = ref<string[]>([]);

    const createCommentTask = useTask(
      (data: { comment: string; issueId: string } | undefined) => createComment(data!.issueId, data!.comment),
    );

    const onCommentAdded = (comment: string) => {
      commentsToCreate.value.push(comment);
    };

    const onIssueCreated = (data: { id: string }) => {
      commentsToCreate.value.forEach(comment => createCommentTask.run({ comment, issueId: data.id }));
      context.emit('issue:created', data);
    };

    return function render() {
      return cols([
        col([
          box([
            issueCreate(
              {
                hideSendButton: props.hideSendButton,
                mergeAttributes: props.mergeAttributes,
              },
              { created: onIssueCreated },
            ),
          ], { class: 'create-edit-issue-page__create-issue-box' }),
        ]),
        col([
          h(IssueCreatePageLogs, {
            on: {
              'comment:add': onCommentAdded,
            },
          }),
        ]),
      ], 'issue-with-logs');
    };
  },
});

export function issueCreateWithLogs(data: VNodeData & { props?: IssueCreateWithLogsProps }) {
  return h(IssueCreateWithLogs, data);
}
